import { useState } from 'react';

import { notificationSuccess } from 'app/core/toast';
import env from 'env';
import i18next from 'i18next';
import UrlUtils from 'utils/url-utils';

import Service from '../../services/passwordRecovery.service';

export const useRecoveryRequest = () => {
  const [loading, setLoading] = useState(false);

  const submitForm = async (userName: string) => {
    setLoading(true);
    try {
      const api = await Service.createRequest(userName);
      if (!api.error) {
        notificationSuccess(i18next.t('security-password-recovery.message.email-sended'));
        window.location.href = UrlUtils.urlConcat(env.appUrl, '/login').toString();
      }
    } catch (error) {
      console.error('Recovery request error:', error);
    } finally {
      setLoading(false);
    }
  };

  return { loading, submitForm };
};
